/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_Suggest_Ask_CpsInputs */



/**
* | output |
* | --- |
* | "What does characters per second (CPS) mean?" |
*
* @param {Assistant_Suggest_Ask_CpsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_suggest_ask_cps = /** @type {((inputs?: Assistant_Suggest_Ask_CpsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Suggest_Ask_CpsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Que signifie « caractères par seconde » (CPS) ?")
	if (locale === "de") return /** @type {LocalizedString} */ ("Was bedeutet Zeichen pro Sekunde (CPS)?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Che cosa significa caratteri al secondo (CPS)?")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Что означает количество символов в секунду (CPS)?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Qué significa caracteres por segundo (CPS)?")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("每秒字符数 (CPS) 是什么意思？")
	if (locale === "ja") return /** @type {LocalizedString} */ ("1秒あたりの文字数（CPS）とはどういう意味ですか？")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कैरेक्टर प्रति सेकंड (CPS) का क्या अर्थ है?")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O que significa caracteres por segundo (CPS)?")
	return /** @type {LocalizedString} */ ("What does characters per second (CPS) mean?")
});